import { ReferenceArea } from 'recharts';
import type { ChartAnnotation } from '../../types/chartAnnotation';
import { DEVICE_COLORS } from '../../utils/colors';

interface ChartAnnotationLayerProps {
  annotations: ChartAnnotation[];
  onAnnotationClick?: (annotation: ChartAnnotation) => void;
}

export function ChartAnnotationLayer({
  annotations,
  onAnnotationClick,
}: ChartAnnotationLayerProps) {
  return (
    <>
      {annotations.map((annotation) => {
        const color = annotation.source
          ? DEVICE_COLORS[annotation.source] || '#6B7280'
          : '#6B7280';

        return (
          <ReferenceArea
            key={annotation.id}
            x1={new Date(annotation.start_time).getTime()}
            x2={new Date(annotation.end_time).getTime()}
            fill={color}
            fillOpacity={0.08}
            stroke={color}
            strokeOpacity={0.3}
            strokeDasharray="4 4"
            onClick={() => onAnnotationClick?.(annotation)}
            style={{ cursor: onAnnotationClick ? 'pointer' : 'default' }}
          />
        );
      })}
    </>
  );
}

export function filterAnnotationsForChart(
  annotations: ChartAnnotation[],
  parameter: string,
  sources?: string[]
): ChartAnnotation[] {
  return annotations.filter((a) => {
    if (!a.parameter) return true;
    if (a.parameter !== parameter) return false;
    if (a.source && sources && !sources.includes(a.source)) return false;
    return true;
  });
}
